<script lang="ts">
    
    import type { Question } from "../../Model/Question";
    import Watch from "../Watch.svelte";
    import { v4 as createUuid } from 'uuid';
    import Editable from "./Editable.svelte";

    export let question: Question;

    const controlId = createUuid();

</script>

<Watch store={question.options.questionOptions} let:value={options}>
    {#each options as option}
        <div class="form-check">
            <input class="form-check-input" type={question.type === 'multiple' ? 'checkbox' : 'radio'} disabled id={controlId}>
            <label class="form-check-label" for={controlId}>
                <Editable store={option.text} />
            </label>
        </div>
    {/each}
</Watch>
